import useSWR, { SWRConfiguration, SWRResponse } from 'swr';
import { DesignAutofillData } from '../../../providers/api/dtos';
import { buildAutofillData } from '../../utils/autofill/autofill';
import { BrandTemplateAutofillDecodedVariable, BrandTemplateAutofillEntitySources } from '../../utils/autofill/types';

export const useAutofillData = (
  variables?: BrandTemplateAutofillDecodedVariable[],
  sources?: BrandTemplateAutofillEntitySources,
  options?: SWRConfiguration<DesignAutofillData | undefined>,
): SWRResponse<DesignAutofillData | undefined> => {
  const key = variables && sources
    ? ['autofill-data', variables.map((v) => v.raw), sources] as const
    : null;

  return useSWR(
    key,
    () => buildAutofillData(variables!, sources!),
    options,
  );
};
